/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    id: z.string(),
    role: z.string(),
    createdAt: z.coerce.date().default(() => new Date()),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    id: z.string(),
    role: z.string(),
    createdAt: z.coerce.date(),
}
).strict();
const relationSchema = z.object({
    user: z.record(z.string(), z.unknown()),
    organization: z.record(z.string(), z.unknown()),
}
);
const fkSchema = z.object({
    userId: z.string(),
    organizationId: z.string(),
}
);

/**
 * `Member` schema excluding foreign keys and relations.
 */
export const MemberScalarSchema = baseSchema;


/**
 * `Member` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const MemberSchema = MemberScalarSchema.merge(fkSchema).merge(relationSchema.partial());


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const MemberPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const MemberPrismaUpdateSchema = z.object({
    id: z.string(),
    role: z.string(),
    createdAt: z.coerce.date()
}).partial().passthrough();


/**
 * `Member` schema for create operations excluding foreign keys and relations.
 */
export const MemberCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    id: true, createdAt: true
});


/**
 * `Member` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const MemberCreateSchema = MemberCreateScalarSchema.merge(fkSchema);


/**
 * `Member` schema for update operations excluding foreign keys and relations.
 */
export const MemberUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `Member` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const MemberUpdateSchema = MemberUpdateScalarSchema.merge(fkSchema.partial());

